module.exports = __webpack_public_path__ + "static/img/site_black.8844f98a.svg";